import { Box } from '@chakra-ui/react';
import type { FC } from 'react';

export interface FaceliftStatusBoxProps {
	status: {
		label: string;
		color: string;
	};
}

const FaceliftStatusBox: FC<FaceliftStatusBoxProps> = ({ status }) => {
	return <Box
		bg={status.color}
		borderRadius={4}
		color="white"
		height="20px"
		px={2}
		display="flex"
		alignItems="center"
		justifyContent="center"
		fontWeight={500}
		fontSize="xs"
	>
		{status.label}
	</Box>;
};

export default FaceliftStatusBox;